export const SWITCH_PREPAY_SCHEDULE_TYPE_REQUEST =
  "SWITCH_PREPAY_SCHEDULE_TYPE_REQUEST";
export const SWITCH_PREPAY_SCHEDULE_TYPE_SUCCESS =
  "SWITCH_PREPAY_SCHEDULE_TYPE_SUCCESS";
export const SWITCH_PREPAY_SCHEDULE_TYPE_ERROR =
  "SWITCH_PREPAY_SCHEDULE_TYPE_ERROR";

export const SET_SECTION_ID = "SET_SECTION_ID";
